<template>
  <div style="margin-bottom: 10px; text-align: left;display: flex; align-items: center;">
    <el-button-group v-if="tableType != 'abandoned'">
      <el-button v-if="prentType != 'smallBag'" type="primary" icon="el-icon-document"
        @click="downloadShipInvoiceDetails">导出发货单
      </el-button>
      <el-button v-if="prentType === 'smallBag'" type="primary" icon="el-icon-document"
        @click="exportShipReceipt">批量导出发货单
      </el-button>
      <el-button v-if="downBtn" type="primary" icon="el-icon-document" @click="downloadProblemItems">批量下载问题商品
      </el-button>
      <!--      // 是否有 '批量生成拣货' 按钮-->
      <el-button :disabled="!isSelect" v-if="packBtn" type="primary" icon="el-icon-takeaway-box"
        @click="createPackReceipt">批量生成拣货
      </el-button>
      <!--      <el-button :disabled="!isSelect" v-if="modifyBtn" type="primary" icon="el-icon-school" @click="modifyCompany">-->
      <!--        批量修改物流公司-->
      <!--      </el-button>-->
      <el-button :disabled="!isSelect" v-if="prentType === 'smallBag' && tableType != 'shipped'" type="primary"
        icon="el-icon-box" @click="dialogVisible = true">批量获取运单号
      </el-button>
      <el-button :disabled="!isSelect" v-if="prentType == 'largeBag' && tableType == 'builtBag'" type="primary"
        @click="batchGetLogisticsFunc">批量获取运单号</el-button>
      <!--      // 是否有 '下载装箱清单' 按钮-->
      <el-button :disabled="!isSelect" v-if="(tableType == 'shipped' &&
        (prentType == 'FBA' || prentType == 'largeBag')) || (tableType == 'builtBag' && prentType == 'largeBag')"
        type="primary" icon="el-icon-download" @click="downloadBoxReceipt">下载装箱清单
      </el-button>
      <el-button :disabled="!isSelect" v-if="finishBtn" type="success" icon="el-icon-circle-check"
        @click="finishHandler">批量确认发货
      </el-button>

    </el-button-group>

    <el-button style="margin-left: 10px;" :disabled="!isSelect || !allOcs"
      v-if="'builtBag,shipped'.includes(tableType) && prentType !== 'smallBag'" type="primary"
      icon="el-icon-circle-check" @click="downOcs">下载OCS面单
    </el-button>

    <el-dialog title="批量获取运单号" :visible.sync="dialogVisible">
      <el-form>
        <el-form-item v-for="(item, index) in selectList" :key="index" :label="'发货单号：' + item.deliveryTaskCode">
          运单号：<el-input maxlength='450' style="width: 300px" v-model="item.logisticsCode"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" style="margin-right: 30px" @click="waybillNumber">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="未上架商品" :visible.sync="pagePickingTaskNo.visible" append-to-body>
      <span v-if="pagePickingTaskNo.pickType == 1" style="color:red">以下商品未上架，请等待上架或触发越库</span>
      <el-table :data="pagePickingTaskNo.list" :border="true" height="600">
        <el-table-column prop="productImg" label="商品图片">
          <template slot-scope="record">
            <ImgView :src="record.row.productImg"></ImgView>
          </template>
        </el-table-column>
        <el-table-column prop="pkgCode" label="批次号">
          <template slot-scope="record">
            <p v-for="item in record.row.pkgCodes" :key="item">{{ item }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="shopProductSku" label="商品SKU"></el-table-column>
        <el-table-column prop="productSku" label="平台SKU"></el-table-column>
      </el-table>
      <el-pagination @size-change="packHandleSizeChange" @current-change="packHandleCurrentChange"
        :current-page.sync="pagePickingTaskNo.current" :page-size="pagePickingTaskNo.pageSize"
        :page-sizes="[10, 20, 40]" layout="total, sizes, prev, pager, next" :total="pagePickingTaskNo.total" background
        style="margin-top: 20px;text-align: right;">
      </el-pagination>
    </el-dialog>
    <el-dialog title="批量获取运单号" :visible.sync="batchVisible" top="2vh" width="720px">
      <div class="batchVisibleBlock">
        <div v-for="i, index in batchLogisticsList" :key="index" class="LogisticsBox">
          <div class="deliveryTaskCode">发货单号:{{ i[0].deliveryTaskCode }}</div>
          <div v-if="i.length > 1" class="boxCodeBlock">
            <div v-for="v, sIndex in i" :key="sIndex" style="margin-bottom: 5px;">
              <div><span style="color: red">*</span>容器{{ v.insidePackCode }} -- {{ v.weight }}g</div>
              <div class="logisticsInputBox">
                <el-input v-model="v.logisticsCode"></el-input>
                <div style="color: red" v-if="!v.logisticsCode && showTips">请输入运单号</div>
              </div>
            </div>
          </div>
          <div v-else class="batchInputBox">
            <span style="color: red">*</span>
            运单号:
            <div class="logisticsInputBox">
              <el-input v-model="i[0].logisticsCode"></el-input>
              <div style="color: red" v-if="!i[0].logisticsCode && showTips">请输入运单号</div>
            </div>
          </div>
          <!-- <div>运单号：<el-input v-model="i." placeholder=""></el-input></div> -->
        </div>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px;">
        <el-button type="primary" @click="updateBatchLogistic">确定</el-button>
        <el-button @click="batchVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { excelExport } from "@/utils/tools";
import Calendar from "@/utils/calendar";
import { createPickTask } from "@/apis/outStock";
import { columns } from "@/views/outOfStock/internationalShipment/components/InterListData";
import {
  batchGetLogisticsNo,
  batchConFirmDeliery,
  downloadPackingList,
  exportDeliveryTask,
  batchEditLogisticsNo,
  b2bExportDeliveryTask,
  pagePickingTaskNotListed,
  asyncExport,
  batchExportNoDeclaratioSku,
  batchGetLogistics,
  batchEditLogistics,
  downloadOcsLabel
} from "@/apis/outStock";

import axios from "axios";
import store from "@/store";
import { baseURL } from "@/const/env";
import ImgView from "@/components/ImgView";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";

export default {
  name: "InterBtnBox",
  components: { ImgView },
  data() {
    return {
      dialogVisible: false,
      batchVisible: false,
      showTips: false,
      batchLogisticsList: [],
      pagePickingTaskNo: {
        list: [],
        current: 1,
        pickType: '',
        total: 0,
        pageSize: 20,
        visible: false,
        saveParams: {}
      },
      selectList: []
    };
  },
  props: {
    shipType: {
      type: String,
      default: (_) => "--",
    }, // 发货类型
    selectedRows: {
      type: Array,
      required: true,
    },
    prentType: {
      // 包裹类型// FBA、普通大包、小包
      type: String,
      required: true,
    },
    tableType: {
      type: String,
    },
    singleProduct: {
      // 单多品： 0 多品，1单品
      type: Number | undefined,
      required: true,
    },
    packBtn: {
      // 是否有 '批量生成拣货' 按钮
      type: Boolean,
      default: (_) => false,
    },
    downBtn: {
      // 是否有 '批量下载问题商品' 按钮
      type: Boolean,
      default: (_) => false,
    },
    modifyBtn: {
      // 是否有 '批量修改物流公司' 按钮
      type: Boolean,
      default: (_) => false,
    },
    finishBtn: {
      // 是否有 '批量确认发货' 按钮
      type: Boolean,
      default: (_) => false,
    },
  },
  watch: {
    selectedRows(newValue){
      this.selectList = JSON.parse(JSON.stringify(newValue))
    }
  },
  computed: {
    allOcs: function () {
      return this.selectedRows.every(i => i.logisticsCompanyCode === "OCS")
    },
    isSelect: function () {
      return !!this.selectedRows && !!this.selectedRows.length;
    },

  },
  methods: {
    async downOcs() {
      const deliveryTaskCodeList = this.selectedRows.map(i => i.deliveryTaskCode)
      const res = await downloadOcsLabel(deliveryTaskCodeList)
      if (res.code == 0) {
        window.open(res.data)
      }
    },
    //下载装箱清单
    downloadShipInvoiceDetails(record) {
      let params
      if (this.selectedRows.length == 0) {
        let formInline = this.getFormInfo()
        params = {
          ...formInline,
          deliveryStatus: deliveryStatus[this.tableType],
          deliveryType: deliveryTypes[this.prentType],
        }
        if (params.deliveryTaskCode && params.deliveryTaskCode.split(',').length) {
          params.deliveryTaskCodeList = params.deliveryTaskCode.split(',')
          delete params.deliveryTaskCode
        }
        if (params.logisticsCodeStr && params.logisticsCodeStr.split(',').length) {
          params.logisticsCodeList = params.logisticsCodeStr.split(',')
          delete params.logisticsCodeStr
        }
      } else {
        params = {
          deliveryTaskCodeList: [],
          deliveryType: deliveryTypes[this.prentType],
        };
        this.selectedRows.forEach((item) => {
          params.deliveryTaskCodeList.push(item.deliveryTaskCode);
        });
      }
      const date = Calendar.d1(Date.now());

      asyncExport(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
      // b2bExportDeliveryTask(params).then((res) => {
      //   let blobObj = new Blob([res.data], { type: "application/octet-stream" });
      //   let blobUrl = window.URL.createObjectURL(blobObj);
      //   const link = document.createElement("a");
      //   link.href = blobUrl;
      //   link.download = date + "装箱清单.xls";
      //   link.click();
      //   window.URL.revokeObjectURL(link.href);
      //   if (code == 0) {
      //     this.$message.success("操作成功");
      //   }
      // });
    },
    // 批量下载问题商品
    downloadProblemItems() {
      const params = {
        deliveryStatus: deliveryStatus[this.tableType],
        deliveryType: deliveryTypes[this.prentType]
      }

      batchExportNoDeclaratioSku(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    },
    // 导出发货单
    exportShipReceipt: function () {
      let params
      if (this.selectedRows.length == 0) {
        let formInline = this.getFormInfo()
        params = {
          ...formInline,
          deliveryStatus: deliveryStatus[this.tableType],
          deliveryType: deliveryTypes[this.prentType],
        }
        if (params.deliveryTaskCode && params.deliveryTaskCode.split(',').length) {
          params.deliveryTaskCodeList = params.deliveryTaskCode.split(',')
          delete params.deliveryTaskCode
        }
        if (params.logisticsCodeStr && params.logisticsCodeStr.split(',').length) {
          params.logisticsCodeList = params.logisticsCodeStr.split(',')
          delete params.logisticsCodeStr
        }
      } else {
        params = {
          deliveryTaskCodeList: [],
          deliveryType: deliveryTypes[this.prentType],
        };
        this.selectedRows.forEach((item) => {
          params.deliveryTaskCodeList.push(item.deliveryTaskCode);
        });
      }
      params.interceptFlag = this.tableType === 'intercept' ? 1 : 0
      asyncExport(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
      // exportDeliveryTask(params).then((res) => {
      //   const date = Calendar.d1(Date.now());
      //   let blobObj = new Blob([res.data], {
      //     type: "application/vnd.ms-excel",
      //   });
      //   let blobUrl = window.URL.createObjectURL(blobObj);
      //   const link = document.createElement("a");
      //   link.href = blobUrl;
      //   link.download = date + "发货单.xls";
      //   link.click();
      //   window.URL.revokeObjectURL(link.href);
      // });
    },
    // 批量生成拣货
    async createPackReceipt() {
      this.errorHandler("再生成拣货！");
      const that = this;
      console.log(that.selectedRows)
      if (that.isSelect) {
        let deliveryTaskCodeList = that.selectedRows.map(
          (item) => item.deliveryTaskCode
        );
        let _pickType = null; // 拣货类型(0:大件 1:小件单品 2:小件多品)
        if (that.prentType == "largeBag") {
          _pickType = 0;
        } else if (that.prentType == "FBA") {
          _pickType = 3;
        } else {
          // 拣货类型(0:大件 1:小件单品 2:小件多品)
          // singleProduct 0:多品 1:单品ing
          let singleProduct = this.selectedRows[0].singleProduct
          if (this.selectedRows.some(item => item.singleProduct !== singleProduct)) {
            this.$message.warning('单品多品无法同时生成拣货任务')
            return false;
          }
          _pickType = [2, 1][singleProduct];
        }
        let params = {
          deliveryTaskCodes: deliveryTaskCodeList,
          shopProductSkus: that.selectedRows.map(v => { return v.taskDetailList.map(item => { return item.shopProductSku }) }).flat(),
          pickType: _pickType,
          current: this.pagePickingTaskNo.current,
          pageSize: this.pagePickingTaskNo.pageSize
        }
        let checkStatus = await pagePickingTaskNotListed(params)
        if (checkStatus.data) {
          const { records = [], total = 0 } = checkStatus.data
          this.pagePickingTaskNo.list = records
          this.pagePickingTaskNo.total = total
          this.pagePickingTaskNo.saveParams = params
          this.pagePickingTaskNo.pickType = _pickType
          this.pagePickingTaskNo.visible = true
          if (_pickType != 1) {
            return
          } else {
            deliveryTaskCodeList = deliveryTaskCodeList.filter(item => !checkStatus.data.records.some(item2 => item2.deliveryTaskCode == item))
          }
        }
        createPickTask({
          deliveryTaskCodeList,
          pickType: _pickType, // 拣货类型(0:大件 1:小件单品 2:小件多品)
        }).then((res) => {
          const { code = -1, data } = res;
          if (code === 0) {
            if (data && data.multiNationFlag) {
              that.$confirm(data.info, `${data.num}个拣货任务`, {
                confirmButtonText: "我知道了",
                type: "success",
                showCancelButton: false,
                closeOnPressEscape: false,
                closeOnClickModal: false
              }).then(() => {
              });
            }
            that.overEmit();
          }
        });
      }
    },
    // 批量修改物流公司
    modifyCompany: function () {
      this.errorHandler("再修改！");
      this.$message.warning("开发中");
    },
    // 批量获取运单号
    waybillNumber: function () {
      console.log(this.selectList);
      let params = {
        deliveryTaskList: [],
      };
      this.selectList.forEach((item) => {
        params.deliveryTaskList.push({
          deliveryTaskCode: item.deliveryTaskCode,
          logisticsCode: item.logisticsCode,
        });
      });
      batchEditLogisticsNo(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("操作成功");
          this.dialogVisible = false
          this.$emit("overEmit");
        }
      });
      // batchGetLogisticsNo(params).then(({ code }) => {
      //   if (code == 0) {
      //     this.$message.success("操作成功");
      //   }
      // });
    },
    // 下载装箱清单
    downloadBoxReceipt: function () {
      let params = {
        deliveryTaskCodeList: [],
      };
      this.selectedRows.forEach((item) => {
        params.deliveryTaskCodeList.push(item.deliveryTaskCode);
      });
      downloadPackingList(params).then((res) => {
        const { code = 0 } = res
        let blobObj = new Blob([res.data], {
          type: "application/octet-stream",
        });
        let blobUrl = window.URL.createObjectURL(blobObj);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "装箱清单.xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
        if (code == 0) {
          this.$message.success("操作成功");
        }
      });
    },
    // 批量确认发货
    finishHandler: function () {
      let params = {
        deliveryTaskCodeList: [],
      };
      this.selectedRows.forEach((item) => {
        params.deliveryTaskCodeList.push(item.deliveryTaskCode);
      });
      batchConFirmDeliery(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("操作成功");
          this.$emit("refeash");
        }
      });
      // TODO
    },
    errorHandler: function (text = "") {
      if (!this.isSelect) {
        this.$message.error("请勾选发货单，" + text);
      }
    },
    overEmit: function () {
      this.$message.success("成功");
      this.$emit("overEmit");
    },
    packHandleCurrentChange(e) {
      this.pagePickingTaskNo.current = e
      this.getpagePickingTaskNoList()
    },
    packHandleSizeChange(e) {
      this.pagePickingTaskNo.pageSize = e
      this.getpagePickingTaskNoList()
    },
    getpagePickingTaskNoList() {
      pagePickingTaskNotListed({
        ...this.pagePickingTaskNo.saveParams,
        current: this.pagePickingTaskNo.current,
        pageSize: this.pagePickingTaskNo.pageSize
      }).then(res => {
        console.log(res)
        this.pagePickingTaskNo.list = res.data.records
      })
    },
    batchGetLogisticsFunc() {
      batchGetLogistics({
        deliveryTaskCodes: this.selectedRows.map(v => v.deliveryTaskCode)
      }).then(res => {
        const batchLogisticsList = {}
        res.data.forEach(i => {
          if (batchLogisticsList[i.deliveryTaskCode]) {
            batchLogisticsList[i.deliveryTaskCode].push(i)
            return
          }
          batchLogisticsList[i.deliveryTaskCode] = [i]
        })
        this.batchLogisticsList = Object.keys(batchLogisticsList).map(v => batchLogisticsList[v])
        this.showTips = false
        this.batchVisible = true
      })
    },
    updateBatchLogistic() {
      const batchLogisticsList = []
      this.showTips = false
      this.batchLogisticsList.forEach(i => {
        i.forEach(v => {
          if (!v.logisticsCode) {
            this.showTips = true
          }
          batchLogisticsList.push(v)
        })
      })
      if (this.showTips) {
        return false
      }
      batchEditLogistics(batchLogisticsList).then(res => {
        if(res.code !== '0') return
        this.batchVisible = false
        this.overEmit();
      })
    }
  },
  inject: ['getFormInfo']
};
</script>

<style scoped>
.batchVisibleBlock {
  max-height: calc(90vh - 100px);
  overflow-y: auto;
}

.LogisticsBox {
  display: flex;
  /* flex-direction: column; */
  margin-bottom: 20px;
}

.LogisticsBox .deliveryTaskCode {
  position: relative;
  bottom: -5px;
}

.LogisticsBox>div {
  /* flex-grow: 1; */
  width: 50%;
}

.LogisticsBox .el-input {
  width: 270px;
}

.LogisticsBox div {
  display: flex;
}

.boxCodeBlock {
  flex-direction: column;
  /* justify-content: flex-start; */
  align-items: flex-start;
}

.boxCodeBlock>div {
  display: flex;
  flex-direction: column;
}

.batchInputBox {
  align-items: center;
}

.logisticsInputBox {
  display: flex;
  /* flex-direction: column; */
}

.batchInputBox .logisticsInputBox {
  /* position: relative;
  bottom: -10px; */
}
</style>
